// extracted by mini-css-extract-plugin
module.exports = {"header":"+mKj0","logo":"_3ZwYk","invalidItem":"EHaZ1"};